import React, { Component } from 'react';

class HistoryIcon extends Component {

	handleChange() {
		this.props.historyToggle();
	}

	render() {
		return (
			<button className={ this.props.cssClass } onClick={ this.handleChange.bind(this) } >

				<svg width="30" height="30" viewBox="0 0 30 30"><title>history_icon</title><path d="M15.364 20.956h2.401v-1.909h-2.401v1.909zm-3.079 0h2.401v-1.909h-2.401v1.909zm-3.08 0h2.402v-1.909H9.206v1.909zm9.238-2.524h2.401v-1.91h-2.401v1.91zm-3.08 0h2.402v-1.91h-2.401v1.91zm-3.078 0h2.401v-1.91h-2.401v1.91zm-3.08 0h2.402v-1.91H9.206v1.91zm9.238-2.525h2.401v-1.909h-2.401v1.909zm-3.08 0h2.402v-1.909h-2.401v1.909zm-3.078 0h2.401v-1.909h-2.401v1.909zm6.485-9.452a.684.684 0 0 0-.682.684v1.973a.683.683 0 1 0 1.366 0V7.138a.684.684 0 0 0-.684-.683zm-8.273.683v1.974a.683.683 0 1 0 1.366 0V7.138a.684.684 0 0 0-1.366 0zm11.301 13.691c0 .845-.689 1.534-1.534 1.534H9.737a1.536 1.536 0 0 1-1.535-1.534v-8.2h13.596v8.2zm1.182-8.2v-2.582c0-1.334-1.178-2.422-2.64-2.459v1.524c0 .866-.704 1.57-1.57 1.57-.866 0-1.57-.704-1.57-1.57V7.585h-4.45v1.527c0 .866-.705 1.57-1.57 1.57-.867 0-1.571-.704-1.571-1.57v-1.52c-1.439.06-2.589 1.136-2.589 2.455v10.78a2.72 2.72 0 0 0 2.717 2.718h10.527a2.72 2.72 0 0 0 2.716-2.718V12.63zM15 0C6.716 0 0 6.716 0 15c0 8.284 6.716 15 15 15 8.284 0 15-6.716 15-15 0-8.284-6.716-15-15-15zm0 1.5c7.444 0 13.5 6.056 13.5 13.5S22.444 28.5 15 28.5 1.5 22.444 1.5 15 7.556 1.5 15 1.5z" fill="#FFF" />
				</svg>
			
				<p>{ this.props.label }</p>
			</button>
		);
	}
}

export default HistoryIcon;



// WEBPACK FOOTER //
// ./app/components/Header/HeaderButton/HistoryIcon.jsx